export const CREATE_BOOKING_EXPERIENCE_CONTACT_START = 'CREATE_BOOKING_EXPERIENCE_CONTACT_START';

export const CREATE_BOOKING_EXPERIENCE_CONTACT_SUCCESS = 'CREATE_BOOKING_EXPERIENCE_CONTACT_SUCCESS';

export const CREATE_BOOKING_EXPERIENCE_CONTACT_FAILED = 'CREATE_BOOKING_EXPERIENCE_CONTACT_FAILED';
